export const node = (state = {}, { type, payload }) => {
  switch (type) {
    case 'NODE/RECEIVE':
      return { ...state, ...payload };
    case 'NODE/REQUEST':
      return { ...state, ...payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/node.js